module.exports = (__parcel__import__("jELoc")).then(() => parcelRequire('lmhgI'));